module.exports = __webpack_public_path__ + "static/img/ad12.7091aef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/ad12.jpg
// module id = G9+/
// module chunks = 0